<section class="analytics-dashboard-panel mb-lg-4 mb-3">

  <div class="d-lg-flex justify-content-between align-items-center">
    <h1 class="page-title mb-lg-0 fw-bold">Analytics Overview</h1>
    <date-range-selector [selected]="dateRange" [todayDate]="true" (dateRangeChanged)="onDateRangeChanged($event)"></date-range-selector>
  </div>

  <section class="vt-border rounded-10 users-container mb-3" *ngIf="tilesData.length > 0">
    <div class="px-3 py-3 row">

      <div class="col-lg-3 user-col" *ngFor="let data of tilesData">
        <div class="d-flex flex-column px-md-3 py-md-0 py-3">
          <div class="d-flex justify-content-between">
            <div>
              <h6 class="font-fraunces fw-semibold heading">{{ data.title }}</h6>
              <p class="font-dm count text-dark-green mb-3 mt-2 pt-1">{{ data.currentPeriodCount }}</p>
            </div>
            <i class="icon-multiple-user fs-3 rounded-10 p-2"></i>
          </div>
          <div class="d-flex justify-content-between">
            <p class="comparison font-14">2 more than yesterday</p>
            <p class="percent font-14 "
               [ngClass]="{'text-success': data.trend === 'increase', 'text-crimson-dark': data.trend !== 'increase'}">
              <i
                [ngClass]="{
                  'icon-arrow-down': data.trend === 'decrease',
                  'icon-arrow-up': data.trend === 'increase'
                }"
              ></i>
              {{ data.percentageChange }}%</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div class="row g-2">
    <div class="col-lg-6 col-md-6">
      <div class="dashboard-card vt-border rounded-10">
        <div class="content p-3">
          <div class="mb-3">
            <h3 class="mb-0">Advertising Categories</h3>
            <p>Users Distributed By Ad Categories</p>
          </div>
          <simple-pie-chart [props]="advertisingCategories" [color]="advertisingCategoriesColorCode"></simple-pie-chart>
        </div>
        <div class="icon-dashboard-card">
        </div>
      </div>
    </div>
    <div class="col-lg-6 col-md-6">
      <div class="dashboard-card vt-border rounded-10">
        <div class="content p-3">
          <div class="mb-3">
            <h3 class="mb-0">Total Views</h3>
            <p>Total Times Pages Were Accessed</p>
          </div>
          <bar-chart [props]="totalViewsChart"></bar-chart>
        </div>
        <div class="icon-dashboard-card">
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-md-12">
      <div class="dashboard-card vt-border rounded-3">
        <div class="content p-3">
          <div class="mb-3">
            <h2>Traffic Source</h2>
            <p>Anonymized Geolocation Data</p>
          </div>
          <MultiLineChart [props]="trafficSource"></MultiLineChart>
        </div>
        <div class="icon-dashboard-card">
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-md-6">
      <div class="dashboard-card vt-border rounded-10">
        <div class="content p-3">
          <div class="d-md-flex justify-content-between mb-md-3 mb-2">
            <div></div>
            <div class="d-flex align-items-center gap-3 mt-md-0 mt-3" *ngIf="overviewData.trafficSourceDetails && overviewData.trafficSourceDetails.length > 0">
              <button class="btn-outlined dark" (click)="exportToExcel()">
                <span class="me-2 icon"><img src="../../../assets/images/export-icon.svg" alt=""></span>
                <span class="text">Export</span>
              </button>
            </div>
          </div>
          <table class="table table-hover">
            <thead>
            <tr>
              <th scope="col" class="font-fraunces">
                <input type="checkbox" class="form-check-input p-0 me-3" id="agreeTerms"/>
                Source
              </th>
              <th scope="col" class="font-fraunces">Sessions</th>
              <th scope="col" class="font-fraunces">Total Events</th>
              <th scope="col" class="font-fraunces">Events Per Sessions (Avg)</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of  this.overviewData.trafficSourceDetails">
              <td class="fw-medium">
                <input type="checkbox" class="form-check-input p-0 me-3"/>
                {{ item.trafficSourceType }}
              </td>
              <td class="fw-semibold text-crimson-dark">{{ item.totalSessions }}</td>
              <td class="fw-medium">{{ item.totalEvents }}</td>
              <td class="fw-medium">{{ item.averageEventsPerSession | number:'1.1-1' }}</td>
            </tr>
            </tbody>
          </table>
        </div>
        <div class="icon-dashboard-card"></div>
      </div>
    </div>

    <div class="col-lg-6 col-md-6">
      <div class="dashboard-card vt-border rounded-10">

        <div class="content p-3">
          <h3 class="mb-0">Device Access</h3>
          <p>Platform Access by Device</p>
          <simple-pie-chart [props]="deviceAccess" [innerRadius]="70" [color]="deviceAccessColorCode"></simple-pie-chart>
        </div>
        <div class="icon-dashboard-card">
        </div>
      </div>
    </div>

    <div class="col-lg-6 geolocation">
      <div class="content p-3 rounded-10 vt-border h-100">
        <div class="mb-3">
          <h3 class="mb-0">Geolocation</h3>
          <p>Privacy-first geolocation</p>
        </div>
        <div class="d-flex justify-content-between gap-2 flex-column">
          <div *ngFor="let item of geoLocation">
            <div>
              <div class="d-flex justify-content-between align-items-center mb-1">
                <p>{{ item.country }}</p>
                <p>{{ item.count }}</p>
              </div>
              <div class="progress bg-transparent">
                <div class="progress-bar bg-purple"
                     [style.width.%]="item.percentage"
                     role="progressbar"
                     [attr.aria-valuenow]="item.percentage"
                     aria-valuemin="0"
                     aria-valuemax="100">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <h3 class="mb-0">Top Articles</h3>
      <p>Most viewed articles</p>
      <Datatable [url]="url" [colDefs]="colDefs"></Datatable>
    </div>
  </div>
</section>
